import React, { FC } from 'react';

import IconRenderer, { IconProps } from 'ui/icons/IconRenderer';

import icon from './credit-card.svg';

const IconCreditCard: FC<IconProps> = ({ className, style }) => (
  <IconRenderer
    iconHtml={icon}
    className={className}
    style={style}
  />
);

export default IconCreditCard;
